import React from 'react'
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import TableCustom from '../../../components/table/tableCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import { debouncedApiCall, handleTypingNumber } from '../../../utils/app.utils';
import ModalCustom from '../../../components/modal/ModalCustom';
import moment from 'moment';

export default function ManageAcademicYear() {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        showModal,
        handleCloseModal,
        form,
        set_form,
        setShowModal,
        handleSubmit
    } = ManageState()
    console.log(form);
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("MANAGE_ACADEMIC_YEAR_MANAGE")}
                // hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("ตั้งค่า"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("เพิ่มปีการศึกษา"),
                //                 pathName: routeName.cms_website.GalleryTypeManagement
                //             },
                //         ]}
                //     />
                // }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("MANAGE_ACADEMIC_YEAR_SEARCH"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },

                                {
                                    type: "COMPONENT",
                                    seq: 2,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("MANAGE_ACADEMIC_YEAR_ADD"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("MANAGE_ACADEMIC_YEAR_ADD") : t("MANAGE_ACADEMIC_YEAR_DETAILS")}
                    subTitle={t("MANAGE_ACADEMIC_YEAR_COMPLETE_INFO_REQUIRED")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form?.academic_year || !form?.academic_year_start || !form?.academic_year_end || !form?.semester_1_start || !form?.semester_1_end,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmit()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'} otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: t("MANAGE_ACADEMIC_YEAR"),
                                            required: true,
                                            value: form?.academic_year,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, academic_year: e.target.value })),
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, academic_year_start: moment(e).format('yyyy-MM-DD') })) },
                                            required: true,
                                            heading: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, academic_year_start: '' }))
                                            },
                                            value: form?.academic_year_start || ''
                                        },
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, academic_year_end: moment(e).format('yyyy-MM-DD') })) },
                                            required: true,
                                            heading: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, academic_year_end: '' }))
                                            },
                                            value: form?.academic_year_end || ''
                                        },
                                    },
                                    {
                                        seq: 4,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: t("MANAGE_ACADEMIC_YEAR_SEMESTER"),
                                            required: true,
                                            disabled: true,
                                            value: '1',
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, academic_year: e.target.value })),
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_1_start: moment(e).format('yyyy-MM-DD') })) },
                                            required: true,
                                            heading: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_1_start: '' }))
                                            },
                                            value: form?.semester_1_start || ''
                                        },
                                    },
                                    {
                                        seq: 6,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_1_end: moment(e).format('yyyy-MM-DD') })) },
                                            required: true,
                                            heading: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_1_end: '' }))
                                            },
                                            value: form?.semester_1_end || ''
                                        },
                                    },
                                    {
                                        seq: 7,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: t("MANAGE_ACADEMIC_YEAR_SEMESTER"),
                                            required: false,
                                            disabled: true,
                                            value: '2',
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, academic_year: e.target.value })),
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 8,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_2_start: moment(e).format('yyyy-MM-DD') })) },
                                            required: false,
                                            heading: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_2_start: '' }))
                                            },
                                            value: form?.semester_2_start || ''
                                        },
                                    },
                                    {
                                        seq: 9,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_2_end: moment(e).format('yyyy-MM-DD') })) },
                                            required: false,
                                            heading: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_2_end: '' }))
                                            },
                                            value: form?.semester_2_end || ''
                                        },
                                    },
                                    {
                                        seq: 10,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 6
                                        },
                                        fieldProps: {
                                            heading: t("MANAGE_ACADEMIC_YEAR_SEMESTER"),
                                            required: false,
                                            disabled: true,
                                            value: '3',
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, academic_year: e.target.value })),
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 11,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_3_start: moment(e).format('yyyy-MM-DD') })) },
                                            required: false,
                                            heading: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_START_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_3_start: '' }))
                                            },
                                            value: form?.semester_3_start || ''
                                        },
                                    },
                                    {
                                        seq: 12,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form((prev: any) => ({ ...prev, semester_3_end: moment(e).format('yyyy-MM-DD') })) },
                                            required: false,
                                            heading: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            placeholder: t('MANAGE_ACADEMIC_YEAR_END_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form((prev: any) => ({ ...prev, semester_3_end: '' }))
                                            },
                                            value: form?.semester_3_end || ''
                                        },
                                    },
                                    
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}
